import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FaAngleDown } from "react-icons/fa6";
import { handleCompanyDetails } from "../../services/companies";

const useStyles = makeStyles({
  chip: {
    marginTop: "4px !important",
    padding: "2px, 8px, 2px, 8px",
    fontFamily: "Inter !important",
    fontSize: "14px",
    lineHeight: "22px",
    fontWeight: "500 !important",
    textAlign: "center",
  },

  selectRoot: {
    "& .MuiOutlinedInput-root": {
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#099250",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderWidth: "1px",
        borderColor: "#099250",
        boxShadow: "0px 0px 0px 4px #D3F8DF",
      },
      "& .MuiSelect-icon": {
        marginRight: "6px",
        marginTop: "-2px",
        width: "20px",
        height: "20px",
      },
      fontFamily: "Inter",
      fontSize: "14px",
      lineHeight: "22px",
      fontWeight: "500",
    },
  },
});

function PolicyFilters({
  handleFilterSelect,
  selectedFilterValue,
  isAdmin = false,
  isTradesman = false,
  loading=false
}) {
  const [lawFirms, setLawFirms] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    if (isAdmin || isTradesman) {
      fetchLawFirms();
    }
  }, [isAdmin, isTradesman]);

  const fetchLawFirms = async () => {
    try {
      const response = await handleCompanyDetails.getCompanies({
        limit: 1000,
      });
      setLawFirms(response.companies_data || []);
    } catch (error) {
      console.error("Error fetching law firms:", error);
      setLawFirms([]);
    }
  };

  const handleChange = (event) => {
    handleFilterSelect(event.target.value);
  };

  if (!isAdmin && !isTradesman) {
    return null;
  }

  return (
    <Form className="d-flex align-items-center filter-gap">
      <FormControl variant="outlined" className={classes.selectRoot}>
        <InputLabel
          sx={{
            marginTop: "-4px",
          }}
          shrink={false}
        >
          {selectedFilterValue ? "" : "Law Firm"}
        </InputLabel>
        <Select
          IconComponent={FaAngleDown}
          value={selectedFilterValue}
          noValidate={false}
          onChange={handleChange}
          disabled={loading}
          sx={{
            borderRadius: "8px",
            border: "1px solid #EAECF0",
            width: "200px",
            padding: "10px 0px",
            height: "46px",
            "&:hover": {
              borderColor: "#099250",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                "& .MuiMenuItem-root": {
                  padding: "0 8px",
                },
                "& .MuiMenuItem-root.Mui-selected": {
                  backgroundColor: "#FFFFFF",
                },
                "& .MuiMenuItem-root:hover": {
                  backgroundColor: "#FFFFFF !important",
                },
              },
            },
          }}
        >
          <MenuItem value="" className={classes.chip}>
            <Chip
              label="All Law Firms"
              size="small"
              style={{
                backgroundColor: "#F9FAFB",
                color: "#344054",
                fontFamily: "Inter",
                fontWeight: "400",
              }}
            />
          </MenuItem>
          {lawFirms.map((firm) => (
            <MenuItem key={firm.id} value={firm.id} className={classes.chip}>
              <Chip
                label={firm.title || firm.company_name}
                size="small"
                style={{
                  backgroundColor: "#ECFDF3",
                  color: "#099250",
                  fontFamily: "Inter",
                  fontWeight: "400",
                }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Form>
  );
}

export default PolicyFilters;
